/* eslint-disable default-param-last */
/* eslint-disable import/no-unresolved */
import { Reducer } from "redux";
import { bindAssignmentClauseApiData } from "src/helpers/FormDetails";
import { initialValues } from "src/helpers/FormDetails/AssignmentClause";
import {
  SAVE_ASSIGNMENT_CLAUSE_DETAILS,
  SET_ASSIGNMENT_CLAUSE_DETAILS
} from "src/redux/Types/assignmentClauseDetails";
import { IAssignmentClauseDetails } from "./interface";

const initialState: IAssignmentClauseDetails = {
  ...initialValues
};

const assignmentClauseDetailsReducer: Reducer<IAssignmentClauseDetails> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SAVE_ASSIGNMENT_CLAUSE_DETAILS: {
      const data = bindAssignmentClauseApiData(
        action.payload?.apiData,
        action.payload?.address,
        action?.payload?.masterData
      );
      const assignorChanged =
        data.assignor !== state.assignor || data.assignorJoint !== state.assignorJoint;
      return {
        ...state,
        ...data,
        ...(assignorChanged ? { witnessSignature: "" } : {})
      };
    }
    case SET_ASSIGNMENT_CLAUSE_DETAILS: {
      const assignorChanged =
        ("assignor" in action.payload && action.payload.assignor !== state.assignor) ||
        ("assignorJoint" in action.payload && action.payload.assignorJoint !== state.assignorJoint);
      return {
        ...state,
        ...action.payload,
        ...(assignorChanged ? { witnessSignature: "" } : {})
      };
    }
    default:
      return state;
  }
};

export default assignmentClauseDetailsReducer;
